import { getBigIntId, getClientAddress, getUserId } from 'common-utils';

import { CommonTrackingProperties } from './use-tracking';

export type ProductDetails = {
  name: string;
  channel: string;
};

export function getEventCommonProperties(
  productDetails: ProductDetails,
): CommonTrackingProperties {
  const bigIntId = getBigIntId();
  const clientAddress = getClientAddress();
  return {
    productName: productDetails.name,
    channel: productDetails.channel,
    pageURL: window?.location?.href,
    pageTitle: document?.title,
    ip: clientAddress?.ip ?? '',
    bigIntId: bigIntId || '',
    ssoUserId: getUserId(),
  };
}
